/* eslint-disable */
import Vue from 'vue';
import { nextTick } from 'vue'
import App from './App.vue';
import BootstrapVue from 'bootstrap-vue';
import router from './router';
// import Breadcrumbs from './components/bread_crumbs';
import { store } from './store';
import firebase from 'firebase/app';
import axios from 'axios';
import Vue2Filters from 'vue2-filters';
import VueSweetalert2 from 'vue-sweetalert2';
import VueFormWizard from 'vue-form-wizard';
import VueTour from 'vue-tour';
import Notifications from 'vue-notification';
import { Vue2Dragula } from 'vue2-dragula';
import Toasted from 'vue-toasted';
import SmartTable from 'vuejs-smart-table';
import * as VueGoogleMaps from 'vue2-google-maps';
import { VueMasonryPlugin } from 'vue-masonry';
import VueFeather from 'vue-feather';
import VueApexCharts from 'vue-apexcharts';
import FunctionalCalendar from 'vue-functional-calendar';
import vueKanban from 'vue-kanban';
import Breadcrumbs from './components/header/empBreadcrumbs';
import CustomCollapse from './components/customCollapse.vue';
import { createUserSnapshot } from './assets/js/trackingSDK'


import PxCard from './components/Pxcard.vue';
import themeCard from './components/themeCard.vue';
Vue.component(PxCard.name, PxCard);

import { Icon } from 'leaflet';
delete Icon.Default.prototype._getIconUrl;

// Import Theme scss
import './assets/scss/app.scss';
import './components/empDownloadStatusToast/emp-download-ui.scss';
import './components/empDownloadStatusToast/emp-export-queue-modal.scss';

// Import Google font css
import './assets/css/font_css_Roboto.css';
import './assets/css/font_css_Rubik.css';

// config for firebase
import config from './config.json';

// config for vee-validation
import VeeValidate from "vee-validate";
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";

//Vue GTM
import VueGtm from 'vue-gtm';

//Kendo UI for Vue
import '@progress/kendo-theme-default/dist/all.css'
import { Grid } from '@progress/kendo-vue-grid'

//Menu, Authentication

import menu from './store/modules/menu'
import { authentication } from './store/modules/authentication'
import {
  loadBrSubmissionStatus,
  isBrFeatureEnabled,
  markBrPostLoginPromptPending,
  resolveKybNavigationRedirect,
  shouldRedirectLockedBrRoute,
  shouldLockSidebarForBr,
  isRouteKybExempt,
} from './constants/businessRegistration'

//Form Component
// import textarea from './components/form/textarea'
import textbox from './components/form/textbox'
import customtextarea from './components/form/textarea'
import datePicker from './components/form/datepicker'
import selection from './components/form/selection.vue';
import texteditor from './components/form/texteditor.vue';
import imageUpload from './components/form/upload/imageUpload.vue';
import videoUpload from './components/form/upload/videoUpload.vue';
import multiselection from './components/form/mutiselection.vue';
import switchIput from './components/form/switch.vue';
import talkBubble from './components/talkBubble.vue';
import mobileOrEmailValidation from "./components/form/mobileOrEmailValidation.vue"
import productSelection from './components/form/productSelection.vue';
import pager from './components/form/pager.vue';
import MultiToggle from './components/form/MultiToggle.vue';
//Custom Component
import visitorPermission from './components/visitorPermission.vue';
import customdate from './components/custom-date.vue';
import datePicker_cp from './components/form/datepicker_cp'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import PublicSelect from "./components/PublicSelect/PublicSelect.vue"
import InputTag from "./components/InputTag/InputTag.vue"
import PublicInput from "./components/PublicInput/PublicInput.vue"
import ConfettiExplosion from "./components/CanvasModel/ConfettiExplosion.vue"
import PublicTabs from "./components/PublicTabs/PublicTabs.vue"
import PublicSwitches from "./components/PublicSwitches/PublicSwitches.vue"
import TipsAndPrivewDilog from "./components/TipsAndPrivewDilog/TipsAndPrivewDilog.vue"
import ImgPrivewDilog from "./components/ImgPrivewDilog/ImgPrivewDilog.vue"
import PageValidate from "./components/PageValidate/PageValidate.vue"
import PhotoPreview from "./components/PhotoPreview/PhotoPreview.vue"
import PubCustomSelect from "./components/PubCustomSelect/PubCustomSelect.vue"
import EmpDownloadStatusToast from "./components/empDownloadStatusToast/EmpDownloadStatusToast.vue";
import empDownloadHudPlugin from "./plugins/empDownloadHud.plugin";
import i18n, { currentLangId as LangId } from '@/plugins/i18n.plugin';
import MessagePopupPlugin from "./plugins/submitFormMessage.plugin";
import draftSaveToastPlugin from "./_helpers/draftSaveToast";

import { userService } from './_services';

Vue.use(MessagePopupPlugin);
Vue.use(draftSaveToastPlugin);
Vue.component('PubCustomSelect', PubCustomSelect);
Vue.component('EmpDownloadStatusToast', EmpDownloadStatusToast);
Vue.use(empDownloadHudPlugin);
Vue.component('PhotoPreview', PhotoPreview);
Vue.component('PageValidate', PageValidate);
Vue.component('TipsAndPrivewDilog', TipsAndPrivewDilog);
Vue.component('ImgPrivewDilog', ImgPrivewDilog);
Vue.component('PublicTabs', PublicTabs);
Vue.component('PublicSwitches', PublicSwitches);
Vue.component('PublicInput', PublicInput);
Vue.component('ConfettiExplosion', ConfettiExplosion);
Vue.component('InputTag', InputTag);
Vue.component('PublicSelect', PublicSelect);
Vue.component('datePicker_cp', datePicker_cp);
Vue.component('textbox', textbox);
Vue.component('customtextarea', customtextarea);
Vue.component('datePicker', datePicker);
Vue.component('pager', pager);
Vue.component('selection', selection);
Vue.component('texteditor', texteditor);
Vue.component('imageUpload', imageUpload);
Vue.component('videoUpload', videoUpload);
Vue.component('multiselection', multiselection);
Vue.component('switchIput', switchIput);
Vue.component('talkBubble', talkBubble);
Vue.component('mobileOrEmailValidation', mobileOrEmailValidation);
Vue.component('productSelection', productSelection);
Vue.component('visitorPermission', visitorPermission);
Vue.component('custom-date', customdate);
Vue.component('MultiToggle', MultiToggle);
Vue.component('ThemeCard', themeCard);

//Api List
import apiList from "./data/apiList.json";
Vue.prototype.$apiList = apiList;
Vue.mixin({
  methods: {
    getApiUrl: function (apiName) {
      return apiList.host + apiList[apiName];
    },
  },
})

//type 0 提示 1 确定框
Vue.prototype.$Alert = function (type, text) {
  this.$swal({
    html: text,
    showCancelButton: false,
    confirmButtonText: this.$t("lbl_EMPBE_Confirm")
  })
  this.$store.state.dirty = false;
};

Icon.Default.mergeOptions({
  iconRetinaUrl: require('./assets/images/vue2leaflet/marker-icon.png'),
  iconUrl: require('./assets/images/vue2leaflet/marker-icon.png')
});

Vue.use(VueFeather);

Vue.use(Toasted, {
  iconPack: 'fontawesome'
});
Vue.use(Vue2Dragula);

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyCdXpLSJ3Ibdu-Phs9QOvpqb9d1DtPf7wQ',
    libraries: 'places',
  },
});
Vue.use(ElementUI);
Vue.use(Notifications);
Vue.use(Vue2Filters);
Vue.use(VueSweetalert2, {
  scrollbarPadding: false // 禁止自动添加 padding-right
});
Vue.use(VueFormWizard);
Vue.use(VueTour);
Vue.use(BootstrapVue, {
  BTooltip: {
    boundary: 'viewport',
    container: 'body',
  },
});
Vue.use(SmartTable);
Vue.use(require('vue-chartist'));
Vue.use(require('vue-moment'));
Vue.component('Breadcrumbs', Breadcrumbs);
Vue.use(VueMasonryPlugin);
Vue.component('apexchart', VueApexCharts);

Vue.component('custom-collapse', CustomCollapse);

Vue.use(FunctionalCalendar, {
  dayNames: ['M', 'T', 'W', 'T', 'F', 'S', 'S']
});
Vue.use(vueKanban);


// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});
// Install VeeValidate components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

//Vue GTM
Vue.use(VueGtm, {
  id: 'GTM-PWC25ZW', // Your GTM single container ID or array of container ids ['GTM-xxxxxx', 'GTM-yyyyyy']
  defer: false, // defaults to false. Script can be set to `defer` to increase page-load-time at the cost of less accurate results (in case visitor leaves before script is loaded, which is unlikely but possible)
  enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
  debug: true, // Whether or not display console logs debugs (optional)
  loadScript: true, // Whether or not to load the GTM Script (Helpful if you are including GTM manually, but need the dataLayer functionality in your components) (optional)
  vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  trackOnNextTick: false, // Whether or not call trackView in Vue.nextTick
});

Vue.prototype.$bus = new Vue();



// setup fake backend
import { configureFakeBackend } from './_helpers';
import { webResourcesService } from './_services';
// configureFakeBackend();

//[04022026][SJP] add userSDKSnapShot

Vue.prototype.$userSnapshot = createUserSnapshot({
  langId : LangId,
  showId : process.env.VUE_APP_EMP_IsUat == "true" ? 9981 : 9991,
  debug : process.env.VUE_APP_EMP_IsUat == "true" ? true : false,
})

var isLoadLang = false;

router.beforeEach(async (to, from, next) => {
  
  
  const JWTuser = authentication.state.user;
  const skipPageBodyLoader =
    (from?.path || '').startsWith('/salesLead') &&
    (to?.path || '').startsWith('/salesLead');
  
  // Set loading state - controls spinner in body.vue
  // Example: store.dispatch('setLoading', true);
  // Example: store.dispatch('setLoading', false);
  // if (!isLoadLang) {
  //   var isrefresh = to.query.isrefresh === 'true' ? true : false;
  //   try {
  //     await webResourcesService.GetWebResourcesValue_byPrefix(currentLang.langid, isrefresh)
  //       .then(        
  //         data => {
  //           i18n.mergeLocaleMessage(currentLang.langid, JSON.parse(data))
  //           //console.log(data)
  //           isLoadLang = true;
  //         }
  //       )

  //   } catch (ex) {
  //     console.log(ex)
  //   }
  // }
  
  if (JWTuser) {
    // 允许已登录用户访问登录成功测试页面（无需权限检查）
    /*
    if (to.path === "/auth/login-success-test") {
      return next();
    }
      */

    if (!skipPageBodyLoader) {
      const kybSidebarLocked = JWTuser.userType === 'USER'
        && isBrFeatureEnabled()
        && shouldLockSidebarForBr(JWTuser);
      const willBlockByKyb = kybSidebarLocked && !isRouteKybExempt(to);
      if (!willBlockByKyb) {
        store.dispatch('setPageBodyLoading', true);
      }
    }


    /* DEBUG ==> Timeout */
  //await new Promise(resolve => setTimeout(resolve, 3000));


    //[20062024][SJP] When JWT token has unaurthorized edit, log the F out
    var JWTValid = await userService.VerifyJWT();
    //console.log('[DEBUG] - main.js JWTValid Response:' , JWTValid);

    if(!JWTValid){
      store.dispatch('authentication/logout');
      return next("/auth/login")
    }

    //
    
    // 检查用户账户信息，如果接口没有返回数据则退出登录
    const accountValid = await store.dispatch('authentication/checkUserAccount')
    //G] - AccountValid:', accountValid);
    if (!accountValid) {
      store.dispatch('authentication/logout');
      return next("/auth/login");
    }

  

    CookieGuid = JWTuser.empCompanyId;

    const menuMutaKey =
      JWTuser.userType == "ADMIN"
        ? "loginAsAdmin"
        : JWTuser.eBoothGrade == "A+" || JWTuser.eBoothGrade == "A" || JWTuser.eBoothGrade == "B"
        ? "loginAsEBoothAB"
        : "loginAsUser";

    menu.mutations[menuMutaKey](menu.state);

    // If direct to admin auth required page with no auth, redirect to supplier home
    // if (to.matched.some(record => record.meta?.requiredAuths?.includes("ADMIN")) && 
    //     JWTuser.userType != "ADMIN") {
    //     return next("/")
    // }
    const HasRouteAccess = store.getters["authentication/HasRouteAccessTo"](to.meta?.AccessRightIDs, to.meta?.AccessRoles)
    
    if (!HasRouteAccess && !JWTuser.IsFullAccess) {
      //redirect to supplier home
      if(JWTuser.userType == "ADMIN"){
        return next("/Management/Index");
      }

      if(JWTuser.userType == "USER"){
        return next("/")
      }
    }

    if (JWTuser.userType == "ADMIN" && (to.redirectedFrom == "/" || to.path == "/dashboard/default")) {
      return next("/Management/Index");
    }

    // 管理員不進供應商 BR 區（代傳在供應商詳情 Tab 內完成）
    if (JWTuser.userType === 'ADMIN' && to.path.indexOf('/businessDocuments') === 0) {
      return next('/Management/Index');
    }

    menu.mutations.appendExtraMenuItem(menu.state)

    const fromLogin = !!(from.path && from.path.indexOf('/auth/login') === 0);
    if (JWTuser.userType === 'USER' && isBrFeatureEnabled()) {
      if (fromLogin) {
        markBrPostLoginPromptPending();
      }
      // 先拉 BR 状态（弹窗/列表）；通行闸另走 AccessGate
      await loadBrSubmissionStatus(fromLogin);
    }

    // KYB 锁定：AccessGate API + 路由 meta.kybExempt；API 失败时回退本地 brLock
    // https://router.vuejs.org/zh/guide/advanced/navigation-guards
    if (JWTuser.userType === 'USER') {
      const brRedirect = await resolveKybNavigationRedirect(JWTuser, to, { forceRefresh: fromLogin });
      if (brRedirect) {
        store.dispatch('setPageBodyLoading', false);
        return next(brRedirect);
      }
    }

    return next();
  }
  else {
    // 公开的认证相关路径（无需登录即可访问）
    const publicAuthPaths = ["/auth/login", "/auth/ResetAccountPassword", "/auth/login-success-test"];
    if (!publicAuthPaths.includes(to.path)) {
      return next("/auth/login");
    }
    return next();
  }
});
router.afterEach((to, from) => {
  store.dispatch('setPageBodyLoading', false);

  const user = store.state.authentication?.user;
  if (user?.userType === 'USER' && isBrFeatureEnabled()) {
    const brRedirect = shouldRedirectLockedBrRoute(user, to);
    if (brRedirect && to.path !== brRedirect) {
      router.replace(brRedirect).catch(() => {});
    }
  }

  UrlName = window.location.pathname;
  //ReferrerUrl = encodeURIComponent(window.location.href);
})

Vue.config.productionTip = false;

// 全局JavaScript错误处理 - 在创建Vue实例之前设置，确保能捕获所有错误
var project = process.env.VUE_APP_EMP_IsUat == "true" ? 'EmpBackUat' : 'EmpBack';
var showid = process.env.VUE_APP_EMP_IsUat == "true" ? 9981 : 9991;

// 全局JavaScript错误处理函数
window.onerror = function(message, source, lineno, colno, error) {
  console.log("日志记录 window.onerror", error);
  console.error('Global JS Error:', message, error);
  const stack = error ? error.stack : '無堆疊資訊';
  const errorMsgText = message??"No Message"; 
  const sourceText = source??"No Source";
  const linenoText = lineno??"No Line Number";
  const colnoText = colno??"No Column Number";
  var errorMsg = project + '，JavaScript Error: ' + errorMsgText + ' || ' + stack + ' || source: ' + sourceText + ' || ' + linenoText + ' || ' + colnoText;
  const parms = new URLSearchParams();
  parms.append("msg", errorMsg);
  
  // 上报错误到数据库，按照参考代码的方式
  axios.post('https://e.adsale.com.hk/WebCoreFormLog/Tracking/ServiceJSErr?showID=' + showid + '&project=' + project, parms);
  
  // 返回false表示不阻止默认错误处理
  return false;
};

// Vue全局错误处理函数
Vue.config.errorHandler = function (err, vm, info) {
  console.log("日志记录 Vue.config.errorHandler", err);
  console.error('Vue Error:', err);
  var errorMsg = project + '，Vue Error: ' + err;
  const parms = new URLSearchParams();
  parms.append("msg", errorMsg);
  
  // 上报错误到数据库，按照参考代码的方式
  axios.post('https://e.adsale.com.hk/WebCoreFormLog/Tracking/ServiceJSErr?showID=' + showid + '&project=' + project, parms);
};

// firebase.initializeApp(config.firebase);

// export const db = firebase.firestore();

// //https://stackoverflow.com/questions/55905055/vue-need-to-disable-all-inputs-on-page
// Vue.directive("disable-all", {
//   // When all the children of the parent component have been updated
//   componentUpdated: function(el, binding, vnode) {
//     if (!binding.value) return;
//     const tags = ["input", "button", "textarea", "select"];
//     const classes = ["ql-editor"];
//     tags.forEach(tagName => {
//       const nodes = el.getElementsByTagName(tagName);
//       for (let i = 0; i < nodes.length; i++) {
//         nodes[i].disabled = true;
//         nodes[i].tabIndex = -1;
//       }
//       //Text Editor
//       const nodes_textEditor = el.getElementsByClassName("ql-editor");
//       for (let i = 0; i < nodes_textEditor.length; i++) {
//         nodes_textEditor[i].contentEditable = false;
//       }
//       //Selection 
//       const nodes_selection = el.getElementsByClassName(["vue-treeselect__x-container","vue-treeselect__value-remove","vue-treeselect__value-remove","vue-treeselect__control-arrow-container","vue-treeselect__menu-container"]);
//       for (let i = 0; i < nodes_selection.length; i++) {
//         nodes_selection[i].remove();
//       }
//     });
//   }
// });

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount('#app');

